// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header-row {\n  background: #F2F3F5 !important;\n  border: 1px solid #E5E6EB;\n}\n", ""]);
// Exports
module.exports = exports;
